/**
 * Tapcart-only lifecycle handler for refreshing stale data
 * Handles BFCache restore and app switching scenarios
 */
(function() {
  // Robust Tapcart detection
  function inApp() {
    try {
      if (window.__isTapcart === true) return true;
      if (window.webkit?.messageHandlers?.Tapcart) return true;           // iOS
      if (typeof window.CustomBlockJavascriptInterface !== 'undefined') return true; // Android
      if (window.Tapcart) return true;
    } catch {}
    return false;
  }

  // Constants
  var DIRTY_KEY = 'pack_dirty';
  var SEEN_KEY = 'pack_dirty_seen';
  var LAST_TS_KEY = '__last_refresh_ts';
  var THROTTLE_MS = 3000;

  // Tracks initial visibility event after load to avoid first-load refresh
  var firstVisibleHandled = false;

  // Safe timestamp helpers
  function getTimestamp(key) {
    try {
      return parseInt(localStorage.getItem(key) || '0', 10);
    } catch (e) {
      return 0;
    }
  }

  function setTimestamp(key, value) {
    try {
      localStorage.setItem(key, String(value));
    } catch (e) {
      // Silently fail if localStorage is not available
    }
  }

  // Page detection helpers
  function isReview() {
    return /^\/pages\/personalised-review(?:\/|$)/.test(window.location.pathname);
  }

  function isAccount() {
    return /^\/account(?:\/|$)/.test(window.location.pathname);
  }

  // Navigation type detection with fallbacks: 'navigate' | 'reload' | 'back_forward' | 'unknown'
  function getNavType() {
    try {
      var entry = (performance && typeof performance.getEntriesByType === 'function')
        ? performance.getEntriesByType('navigation')[0]
        : null;
      if (entry && entry.type) return entry.type; // modern: 'navigate' | 'reload' | 'back_forward'
      if (performance && performance.navigation && typeof performance.navigation.type === 'number') {
        switch (performance.navigation.type) {
          case 0: return 'navigate';
          case 1: return 'reload';
          case 2: return 'back_forward';
          default: return 'unknown';
        }
      }
    } catch (e) {}
    return 'unknown';
  }

  // Check if refresh is needed and not throttled
  function shouldRefresh() {
    var now = Date.now();
    var lastRefresh = getTimestamp(LAST_TS_KEY);
    
    // Throttle check - prevent multiple refreshes within THROTTLE_MS
    if (now - lastRefresh < THROTTLE_MS) {
      return false;
    }
    
    // Compare dirty timestamp with last seen timestamp
    var packDirty = getTimestamp(DIRTY_KEY);
    var lastSeen = getTimestamp(SEEN_KEY);
    
    return packDirty > 0 && packDirty > lastSeen;
  }

  // Perform the refresh
  function refreshPage() {
    var now = Date.now();
    
    // Update throttle timestamp
    setTimestamp(LAST_TS_KEY, now);
    
    // Only refresh Review and Account pages
    if (isReview()) {
      // Update seen timestamp before reload
      setTimestamp(SEEN_KEY, getTimestamp(DIRTY_KEY) || 0);
      location.reload();
    } else if (isAccount()) {
      // Update seen timestamp before reload
      setTimestamp(SEEN_KEY, getTimestamp(DIRTY_KEY) || 0);
      location.reload();
    }
  }

  // Initialize listeners
  function init() {
    // BFCache restore listener
    window.addEventListener('pageshow', function(event) {
      var navType = getNavType();
      if ((event.persisted === true || navType === 'back_forward') && shouldRefresh()) {
        refreshPage();
      }
    });

    // App visibility change listener (for app switching)
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState !== 'visible') return;
      
      // Tapcart-specific bypass for dirty pack refresh (Issue B fix)
      if (inApp() && shouldRefresh() && !window.__tapcartBackBypassed) {
        window.__tapcartBackBypassed = true;
        // Mark seen to avoid refresh loops
        try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch(e){}
        return refreshPage();
      }
      
      if (!firstVisibleHandled) { firstVisibleHandled = true; return; }
      if (shouldRefresh()) { refreshPage(); }
    });

    // Focus fallback for additional back-navigation detection
    window.addEventListener('focus', function() {
      // Tapcart-specific bypass mirror (fallback if visibilitychange unreliable)
      if (inApp() && shouldRefresh() && !window.__tapcartBackBypassed) {
        window.__tapcartBackBypassed = true;
        try { localStorage.setItem(SEEN_KEY, String(Date.now())); } catch(e){}
        return refreshPage();
      }
      
      // Only after initial visible has been seen (so we don't fire on first load),
      // and still guarded by shouldRefresh() which enforces throttle and dirty check.
      if (firstVisibleHandled && shouldRefresh()) {
        refreshPage();
      }
    });
  }

  // Delayed initialization - wait for Tapcart detection
  function initWhenReady() {
    var attempts = 0;
    var maxAttempts = 80; // ~2 seconds with 25ms intervals
    
    function checkAndInit() {
      if (inApp()) {
        init();
        return;
      }
      
      attempts++;
      if (attempts < maxAttempts) {
        setTimeout(checkAndInit, 25);
      }
    }
    
    checkAndInit();
  }

  // Start initialization
  initWhenReady();

})();
